<template>
  <basic-container>
    <div class="path-container" style="margin-bottom: 20px; padding: 10px 15px; border-radius: 4px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>超级智能体工作站</el-breadcrumb-item>
        <el-breadcrumb-item>高血压智能体</el-breadcrumb-item>
        <el-breadcrumb-item>行为认知治疗</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div style="margin-bottom: 1vh; padding: 0px 0px; border-radius: 4px">
      <el-breadcrumb separator="/">
        <!-- <el-breadcrumb-item :to="{ path: '/index' }">&lt;</el-breadcrumb-item> -->
        <i class="el-icon-back" style="font-size: 20px; font-weight: bolder" @click="back()"></i>
      </el-breadcrumb>
    </div>

    <el-button-group>
      <el-button class="healthButton" @click="click(0)">数字档案</el-button>
      <el-button class="healthButton" @click="click(2)">血压统计数据</el-button>
      <el-button class="healthButton" @click="click(3)">运动处方</el-button>
      <el-button class="healthButton" @click="click(1)">营养处方</el-button>
      <el-button class="healthButton healthActive" @click="click(4)">行为认知治疗</el-button>
      <el-button class="healthButton" @click="click(6)">药物方案</el-button>
      <el-button class="healthButton" @click="click(5)">运动随访</el-button>
    </el-button-group>
    <div class="card-row" style="margin-bottom: 20px">
      <div class="card card01">
        <div class="card-row" style="font-size: 20px; font-weight: bold; margin-bottom: 2vh">
          {{ info.name }}
        </div>
        <div class="card03" style="font-size: 14px">
          <div>性别：{{ info.sex === 1 ? '男' : info.sex === 2 ? '女' : '未填写' }}</div>
          <div>手机号码：{{ info.mobile }}</div>
        </div>
        <div class="card03" style="font-size: 14px">
          <div>年龄|生日：{{ info.age }}岁 / 未填写</div>
          <div>身高|体重：{{ info.height ? info.height : ' ' }}cm/{{ info.weight ? info.weight : ' ' }}kg</div>
          <div>身份证号：{{ info.idCard }}</div>
        </div>
      </div>
    </div>

    <el-calendar v-model="punchDate" ref="calendar">
      <template slot="dateCell" slot-scope="{ data }">
        <div class="custom-cell" @click="handleDateClick(data)" :style="getStyle(data)">
          {{ data.day.split('-')[2] }}
          <span v-if="gou(data)" class="selected-mark">✔️</span>
          <div class="punchCell" v-if="isThisMonth(data)">
            <div class="punchLabel" v-if="isShow(data, 1)">
              <div>服药</div>
              <div>💊</div>
            </div>
            <div class="punchLabel" v-if="isShow(data, 2)">
              <div>就餐</div>
              <div>🍚</div>
            </div>
            <div class="punchLabel" v-if="isShow(data, 3)">
              <div>运动</div>
              <div>👟</div>
            </div>
            <!-- <div class="punchLabel">
              <div>睡眠</div>
              <div>🛌</div>
            </div> -->
          </div>
        </div>
      </template>
    </el-calendar>

    <avue-crud :option="option" :data="data" ref="crud" v-model="form" :permission="permissionList" :page.sync="page" @on-load="onLoad" style="margin-bottom: 20px">
      <template slot="menuLeft"></template>
    </avue-crud>

    <div class="card-container">
      <div class="card-row">
        <div class="card card01">
          <!-- <div
            class="card-row"
            style="font-size: 20px; font-weight: bold; margin-bottom: 2vh"
          >
            就餐详情
          </div> -->
          <div class="card-row tital01">
            <div>就餐详情 - {{ gouDate }}</div>
            <div style="position: absolute; right: 1px; font-size: 15px">摄入能量：{{ todayEat.energy }} 千卡</div>
          </div>
          <div style="display: flex; margin-bottom: 10px">
            <div style="font-size: 17px">早餐：</div>
            <div class="card02">
              <div v-for="(food, index) in todayEat.breakfast" :key="index" class="foodLabel">
                <div style="font-size: 15px">{{ food.name }}</div>
                <div style="font-size: 12px">{{ '(' + food.num + 'g)' }}</div>
              </div>
              <div class="foodLabel">
                <div style="font-size: 15px">..</div>
                <div style="font-size: 12px">..</div>
              </div>
            </div>
          </div>

          <div style="display: flex; margin-bottom: 10px">
            <div style="font-size: 17px">午餐：</div>
            <div class="card02">
              <div v-for="(food, index) in todayEat.lunch" :key="index" class="foodLabel">
                <div style="font-size: 15px">{{ food.name }}</div>
                <div style="font-size: 12px">{{ '(' + food.num + 'g)' }}</div>
              </div>
              <div class="foodLabel">
                <div style="font-size: 15px">..</div>
                <div style="font-size: 12px">..</div>
              </div>
            </div>
          </div>

          <div style="display: flex; margin-bottom: 10px">
            <div style="font-size: 17px">晚餐：</div>
            <div class="card02">
              <div v-for="(food, index) in todayEat.dinner" :key="index" class="foodLabel">
                <div style="font-size: 15px">{{ food.name }}</div>
                <div style="font-size: 12px">{{ '(' + food.num + 'g)' }}</div>
              </div>
              <div class="foodLabel">
                <div style="font-size: 15px">..</div>
                <div style="font-size: 12px">..</div>
              </div>
            </div>
          </div>

          <div style="margin-bottom: 10px">
            <div style="font-size: 17px">加餐：</div>
            <div class="card02">
              <div v-for="(food, index) in todayEat.extraMeal" :key="index" class="foodLabel">
                <div style="font-size: 15px">{{ food.name }}</div>
                <div style="font-size: 12px">{{ '(' + food.num + 'g)' }}</div>
              </div>
              <div class="foodLabel">
                <div style="font-size: 15px">..</div>
                <div style="font-size: 12px">..</div>
              </div>
            </div>
          </div>

          <div class="card-row tital01">
            <div style="position: absolute; right: 1px; font-size: 15px">
              <div>可摄入总能量：{{ todayMotion.edibleEmergy }} 千卡</div>
            </div>
          </div>
        </div>
      </div>

      <div class="card-row">
        <div class="card card01">
          <div class="card-row tital01">
            <div>运动详情</div>
            <div style="position: absolute; right: 1px; font-size: 15px">消耗能量：{{ todayMotion.consume }} 千卡</div>
          </div>
          <div style="padding:1%" v-if="todayMotion.motion.length>0">
            <!-- <div class="totalTitle">
              <div>运动详情</div>
              <div>消耗能量：<span>{{ todayMotion.consume }}</span> 千卡 </div>
            </div> -->
            <div class="content">
              <div class="left" v-for="(motion, index) in todayMotion.motion" :key="index">
                <div class="title">
                  <img src="@/assets/img/heart/sport.png" />
                  <div>{{ motion.name }}<span>{{ motion.distance }}</span> 用时<span></span><span></span>{{ Math.floor(motion.time / 60) > 0 ? Math.floor(motion.time / 60) + '小时' + (motion.time % 60) + '分钟' : (motion.time % 60) + '分钟' }}</div>
                </div>
                <div class="sport" v-if="motion.bodyType == 1">
                  <div class="hr">
                    <img src="@/assets/img/heart/height.png" />
                    <div>最高心率</div>
                    <div><span>{{motion.hrMax?motion.hrMax:'..'}}</span> 次/分</div>
                  </div>
                  <div class="hr">
                    <img src="@/assets/img/heart/low.png" />
                    <div>最低心率</div>
                    <div><span>{{motion.hrMin?motion.hrMin:'..'}}</span> 次/分</div>
                  </div>
                  <div class="hr">
                    <img src="@/assets/img/heart/avage.png" />
                    <div>平均心率</div>
                    <div><span>{{motion.hrAvg?motion.hrAvg:'..'}}</span> 次/分</div>
                  </div>
                  <div class="hr">
                    <img src="@/assets/img/heart/heartRate.png" />
                    <div>靶心率</div>
                    <div><span>{{ motion.thrMax ? motion.thrMin + "-" + motion.thrMax : '..' }}</span> 次/分</div>
                  </div>
                  <div class="hr">
                    <img src="@/assets/img/heart/goat.png"/>
                    <div style="margin-top:12px;">强度达标率</div>
                    <div><span>{{ motion.thrMax ? motion.thrRate: '..' }}</span> %</div>
                  </div>
                </div>
                <div class="sport" v-if="motion.bodyType == 2">
                    <div class="hr">
                      <img src="@/assets/img/heart/power4.png" />
                      <div>重量</div>
                      <div><span>{{ motion.dumbbell ? motion.dumbbell : '..' }}</span> kg</div>
                    </div>
                    <div class="hr">
                      <img src="@/assets/img/heart/power.png" />
                      <div>数量</div>
                      <div><span>{{ motion.group ? motion.group : '..' }}</span> 组</div>
                    </div>
                    <div class="hr">
                      <img src="@/assets/img/heart/power2.png" />
                      <div>每组数量</div>
                      <div><span>{{ motion.oneGroup ? motion.oneGroup : '..' }}</span> 个 / 组</div>
                    </div>
                    <!-- <div class="hr">
                      <img src="@/assets/img/heart/power3.png" />
                      <div>靶心率</div>
                      <div><span>{{ motion.thrMax ? motion.thrMin + "-" + motion.thrMax : '..' }}</span> 次/分</div>
                    </div> -->
                    <div class="hr">
                      <img src="@/assets/img/heart/power1.png" />
                      <div>RM指标</div>
                      <div><span>{{ motion.rm ? motion.oneGroup : '..' }}</span> RM</div>
                    </div>
                </div>
              </div>
              <!-- <div v-for="(motion, index) in todayMotion.motion" :key="index" class="foodLabel">
                <div style="font-size: 16px; margin-bottom: 5px">
                  {{ motion.name }}
                </div>
                <div style="font-size: 12px">{{ motion.distance }}</div>
                <div style="font-size: 12px">
                  {{ Math.floor(motion.time / 60) > 0 ? Math.floor(motion.time / 60) + '小时' + (motion.time % 60) + '分钟' : (motion.time % 60) + '分钟' }}
                </div>
                <div v-if="motion.bodyType == 1" style="font-size: 14px; margin-top: 20px">
                  {{ motion.hrMax ? '最高心率: ' + motion.hrMax + "次/分" : '..' }}
                </div>
                <div v-if="motion.bodyType == 1" style="font-size: 14px; margin-top: 2px">
                  {{ motion.hrMin ? '最低心率: ' + motion.hrMin + "次/分" : '..' }}
                </div>
                <div v-if="motion.bodyType == 1" style="font-size: 14px; margin-top: 2px">
                  {{ motion.hrAvg ? '平均心率: ' + motion.hrAvg + "次/分" : '..' }}
                </div>
                <div v-if="motion.bodyType == 2" style="font-size: 14px; margin-top: 20px">
                  {{ motion.dumbbell ? motion.dumbbell + 'kg' : '..' }}
                </div>
                <div v-if="motion.bodyType == 2" style="font-size: 14px; margin-top: 2px">
                  {{ motion.group ? motion.group + '组' : '..' }}
                </div>
                <div v-if="motion.bodyType == 2" style="font-size: 14px; margin-top: 2px">
                  {{ motion.oneGroup ? motion.oneGroup + '个 / 组' : '..' }}
                </div>
                <div v-if="motion.bodyType == 2" style="font-size: 14px; margin-top: 2px">
                  {{ motion.rm ? motion.oneGroup + 'RM' : '..' }}
                </div>

                <div style="font-size: 14px; margin-top: 2px">
                  {{ motion.thrMax ? '靶心率: ' + motion.thrMin + "-" + motion.thrMax + "次/分" : '..' }}
                </div>
                <div style="font-size: 14px; margin-top: 2px">
                  {{ motion.thrMax ? '强度达标率: ' + motion.thrRate + "%" : '..' }}
                </div>
              </div>
              <div class="foodLabel">
                <div style="font-size: 15px">..</div>
                <div style="font-size: 12px">..</div>
              </div> -->
            </div>
          </div>
          <div v-else style="text-align: center;padding:5%;">今日还没有运动数据哦~</div>
        </div>
      </div>
    </div>
  </basic-container>
</template>

<script>
import { getBehavior, getBehaviorThisMonth, getFoodMenuToday, getMotionToday, getUserJkDetail } from '@/api/health/manage'
import { mapGetters } from 'vuex'
import func from '@/util/func'

export default {
  data() {
    return {
      wxUserid: this.$route.query.wxUserId,
      info: {},
      form: {},
      punchDate: '',
      gouDate: '',
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      selectionList: [],
      option: {
        tip: false,
        border: true,
        // index: true,
        viewBtn: true,
        editBtn: false,
        addBtn: false,
        delBtn: false,
        menu: false,
        // selection: true,
        column: [
          {
            label: '日历打卡页面',
            prop: 'today'
          },
          {
            label: '服药打卡及时间',
            prop: 'drug',
            formatter: row => {
              return row.drug !== '' ? `✓ ${row.drug}` : '✗ 未打卡'
            }
          },
          {
            label: '检验检查项目及规划时间',
            prop: 'check'
          },
          {
            label: '临床营养早、中、晚、加餐打卡时间',
            prop: 'eat',
            formatter: row => {
              return row.eat !== '' ? `✓ ${row.eat}` : '✗ 未打卡'
            }
          },
          {
            label: '运动打卡完成情况及统计',
            prop: 'move',
            formatter: row => {
              return row.move !== '' ? `✓ ${row.move}` : '✗ 未打卡'
            }
          },
          {
            label: '睡眠障碍指导',
            prop: 'heartRate'
          },
          {
            label: '睡眠时间打卡',
            prop: 'sleep',
            formatter: row => {
              return row.sleep !== '' ? `✓ ${row.sleep}` : '✗ 未打卡'
            }
          },
          {
            label: '睡眠知识阅读完成情况',
            prop: 'heartRate'
          },
          {
            label: 'CBT-i完成情况',
            prop: 'CBT',
            formatter: row => {
              return row.CBT !== '' ? `✓ ${row.CBT}` : '✗ 未打卡'
            }
          }
        ]
      },
      data: [],
      thisMonthPunch: {},
      todayEat: {
        breakfast: [],
        lunch: [],
        dinner: [],
        extraMeal: [],
        energy: 0
      },
      todayMotion: {
        motion: {},
        consume: 0,
        edibleEmergy: 0
      },
      healthBmi: {}
    }
  },
  mounted() {
    // 点击上一个月
    const prevBtn = document.querySelector('.el-calendar__button-group .el-button-group>button:nth-child(1)')
    prevBtn.addEventListener('click', () => {
      const year = this.punchDate.getFullYear()
      const month = String(this.punchDate.getMonth() + 1).padStart(2, '0')
      const day = String(this.punchDate.getDate()).padStart(2, '0')
      const punch = year + '-' + month + '-' + day
      console.log(punch)
      console.log('这是上个月')
      this.gouDate = punch
      getBehaviorThisMonth(this.wxUserId, punch).then(res => {
        this.thisMonthPunch = res.data
      })
      getFoodMenuToday(this.wxUserId, punch).then(res => {
        if (res.success) this.todayEat = res.data
      })
      getMotionToday(this.wxUserId, punch).then(res => {
        if (res.success) this.todayMotion = res.data
      })
    })

    const spanDoc = document.querySelector('.el-calendar__button-group .el-button-group>button:nth-child(2) span')
    // spanDoc.innerText = '当月'
    spanDoc.addEventListener('click', () => {
      setTimeout(() => {
        console.log(this.punchDate)
        console.log(new Date())
        this.punchDate = new Date()
        const year = this.punchDate.getFullYear()
        const month = String(this.punchDate.getMonth() + 1).padStart(2, '0')
        const day = String(this.punchDate.getDate()).padStart(2, '0')
        const punch = year + '-' + month + '-' + day
        console.log(punch)
        console.log('今天')
        this.gouDate = punch
        getBehaviorThisMonth(this.wxUserId, punch).then(res => {
          this.thisMonthPunch = res.data
          console.log(res.data)
        })
        getFoodMenuToday(this.wxUserId, punch).then(res => {
          if (res.success) this.todayEat = res.data
        })
        getMotionToday(this.wxUserId, punch).then(res => {
          if (res.success) this.todayMotion = res.data
        })
      }, 100)
    })

    // 点击上一个月
    const nextBtn = document.querySelector('.el-calendar__button-group .el-button-group>button:nth-child(3)')
    nextBtn.addEventListener('click', () => {
      const year = this.punchDate.getFullYear()
      const month = String(this.punchDate.getMonth() + 1).padStart(2, '0')
      const day = String(this.punchDate.getDate()).padStart(2, '0')
      const punch = year + '-' + month + '-' + day
      console.log(punch)
      console.log('这是下个月')
      this.gouDate = punch
      getBehaviorThisMonth(this.wxUserId, punch).then(res => {
        this.thisMonthPunch = res.data
      })
      getFoodMenuToday(this.wxUserId, punch).then(res => {
        if (res.success) this.todayEat = res.data
      })
      getMotionToday(this.wxUserId, punch).then(res => {
        if (res.success) this.todayMotion = res.data
      })
    })
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.permission.health_userjk_add,
        viewBtn: this.permission.health_userjk_view,
        delBtn: this.permission.health_userjk_delete,
        editBtn: this.permission.health_userjk_edit
      }
    },
    ids() {
      const ids = []
      this.selectionList.forEach(ele => {
        ids.push(ele.id)
      })
      return ids.join(',')
    }
  },
  methods: {
    onLoad() {
      if (this.punchDate === '') {
        this.punchDate = new Date()
      }
      const year = this.punchDate.getFullYear()
      const month = String(this.punchDate.getMonth() + 1).padStart(2, '0')
      const day = String(this.punchDate.getDate()).padStart(2, '0')

      const wxUserId = this.$route.query.wxUserId
      this.wxUserId = wxUserId

      getUserJkDetail(wxUserId).then(res => {
        const wxUserId = window.localStorage.getItem('pcUserId');
        if (wxUserId === '2043870969731301377') {
          res.data.userJk.name = func.maskName(res.data.userJk.name);
          res.data.userJk.mobile = func.maskPhone(res.data.userJk.mobile);
        }
        this.info = res.data.userJk
      })

      const date = year + '-' + month + '-' + day
      getBehavior(wxUserId, date).then(res => {
        this.data = res.data
      })
      getBehaviorThisMonth(this.wxUserId, date).then(res => {
        this.thisMonthPunch = res.data
      })
      getFoodMenuToday(this.wxUserId, date).then(res => {
        if (res.success) this.todayEat = res.data
      })
      getMotionToday(this.wxUserId, date).then(res => {
        if (res.success) this.todayMotion = res.data
        console.log('this.todayMotion', this.todayMotion)
      })
    },

    gou(date) {
      if (this.gouDate === '') {
        const newDate = new Date()
        this.punchDate = newDate
        const year = newDate.getFullYear()
        const month = String(newDate.getMonth() + 1).padStart(2, '0')
        const day = String(newDate.getDate()).padStart(2, '0')
        this.gouDate = year + '-' + month + '-' + day
      }
      return date.day === this.gouDate
    },

    handleDateClick(date) {
      const newDate = new Date(date.day)
      const year = newDate.getFullYear()
      const month = String(newDate.getMonth() + 1).padStart(2, '0')
      const day = String(newDate.getDate()).padStart(2, '0')
      this.punchDate = newDate
      this.gouDate = year + '-' + month + '-' + day

      getBehaviorThisMonth(this.wxUserId, date.day).then(res => {
        this.thisMonthPunch = res.data
      })
      getFoodMenuToday(this.wxUserId, date.day).then(res => {
        if (res.success) this.todayEat = res.data
        console.log('food', date.day)
      })
      getMotionToday(this.wxUserId, date.day).then(res => {
        if (res.success) this.todayMotion = res.data
      })
      getBehavior(this.wxUserId, date.day).then(res => {
        this.data = res.data
      })
    },

    isShow(date, index) {
      const i = Number(date.day.substr(5, 2))
      const j = Number(date.day.substr(8, 2))

      switch (Number(index)) {
        case 1:
          if (this.thisMonthPunch.drug != null) {
            return this.thisMonthPunch.drug[i][j] === 1
          }
          break
        case 2:
          if (this.thisMonthPunch.eat != null) {
            return this.thisMonthPunch.eat[i][j] === 1
          }
          break
        case 3:
          if (this.thisMonthPunch.move != null) {
            return this.thisMonthPunch.move[i][j] === 1
          }
          break
      }
    },

    searchBtn(load) {
      this.onLoad()
    },

    isThisMonth(date) {
      const newDate = new Date(this.punchDate)
      const month = date.day.substr(5, 2)
      const punchMonth = String(newDate.getMonth() + 1).padStart(2, '0')
      return month === punchMonth
    },

    getStyle(date) {
      // 只设置文字颜色，不设置背景色
      if (date.day === this.gouDate) {
        return 'background: #F2F8FE'
      }
      return ''
    },

    click(index) {
      let path = ''
      switch (index) {
        case 0:
          path = '/agent/blood/archive'
          break
        case 1:
          path = '/agent/blood/nutritionalPlan'
          break
        case 2:
          path = '/agent/blood/bodyComposition'
          break
        case 3:
          path = '/agent/blood/exercisePlan'
          break
        case 4:
          path = '/agent/blood/behavioralTherapy'
          break
        case 5:
          path = '/agent/blood/sportsFollow'
          break
        case 6:
          path = '/agent/blood/drugRegimen'
          break
      }
      const parameter = {
        wxUserId: this.wxUserId
      }
      this.$router.push({
        path: path,
        query: parameter
      })
    },

    back() {
      // this.$router.go(-1);
      this.$router.push({
        path: '/agent/blood/blood'
      })
    }
  }
}
</script>

<style scoped>
.custom-cell {
  height: 100%;
  width: 100%;
  /* display: flex; */
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
}

.custom-cell1 {
  background-color: #ffebee;
}

.punchCell {
  font-size: 13px;
  margin-top: 3px;
  display: flex;
  /* display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr; */
}

.punchLabel {
  margin-right: 10px;
  display: grid;
  justify-items: center;
  font-weight: bold;
}

.card-container {
  width: 100%;
  max-width: 100vw; /* 可根据需要调整最大宽度 */
  margin: 0 auto;
  padding: 1vw;
  box-sizing: border-box;
  background: #f0f2f5;
}

.card-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1vw;
}

.card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 1vw;
  box-sizing: border-box;
}

.foodLabel {
  display: grid;
  justify-items: center;
  font-weight: bold;
}

.card01 {
  flex: 1;
  height: auto;
}

.totalTitle{
  width: 11%;
  background: #57B8EF;
  color: #FFF;
  text-align: center;
  margin-right:2%;
}
.totalTitle div:first-child{
  margin-top: 40%;
  font-size: 18px;
  height: 50px;
  width: 60%;
  margin-left: 20%;
  font-weight: bold;
  border-bottom: 1px dashed #fff;
}
.totalTitle div:last-child{
  margin-top: 20px;
  font-size: 14px;
}
.totalTitle div:last-child span{
  font-size: 20px;
  font-weight: bold;
}
.card02 {
  width: 100%;
  min-width: 900px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
  /* margin-bottom: 2vh; */
  /* border: 1px solid red;
  display: flex;
  flex-wrap: wrap;
  justify-content: center; */
}
.content{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  /* border: 1px solid red; */
  /* padding: 2% 10%; */
}
.left{
  min-width: 33%;
  padding: 20px 2%;
  border-radius: 24px;
  border: 0.5px solid #B8B7BC;
  background-color: #EEF9FD;
  margin-top: 10px;
}
.sport{
  width: 100%;
  padding: 0 2%;
  /* border: 1px solid red; */
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.left .title{
  display: flex;
  padding: 0 2% 20px 2%;
}
.left .title img{
  width: 20px;
  height: 20px;
  margin-right: 8px;
  margin-top: 2px;
}
.left .title div span{
  color: #57B8EF;
}
.sport .hr{
  width: 15%;
  border-radius: 24px;
  border: 0.5px solid #B8B7BC;
  margin-right: 2%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding:1% 0 3% 0;
}
.sport .hr img{
  margin:0 auto;
  width: 34px;
  height: 34px;
}
.sport .hr div{
  color: #B8B7BC;
  font-size: 15px;
  text-align: center;
  margin-top: 24px;
}
.sport .hr div:last-child{
  margin-top: 10px;
  font-size: 13px;
  line-height: 30px;
}
.sport .hr div span{
  color: #352973;
  font-size: 18px;
  font-weight: 600;
}

.tital01 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 2vh;
  width: 100%;
  position: relative;
}

.card03 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  margin-bottom: 2vh;
}

.healthButton {
  /* background-color: #ebedf0; */
  color: black;
  border: 0px solid #c1c3c5;
  border-bottom: none;
  font-size: 15px;
  border-radius: 0px;
  margin-bottom: 2px;
}
.healthActive {
  border-bottom: 3px solid #409eff;
  color: #409eff;
  font-weight: bold;
}
</style>
